import styled from 'styled-components';

import { style } from '@genially/design-system';

export const ScrollArea = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.size.units(2),
  flex: 1,
  overflowY: 'auto',

  padding: `${theme.size.units(2)} 0`,

  ...style.mixins.scrollbar(theme),
}));
